import { render, staticRenderFns } from "./ComLogout.vue?vue&type=template&id=076afd20&"
import script from "./ComLogout.vue?vue&type=script&lang=js&"
export * from "./ComLogout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports